/** 停止滚动后多久隐藏滑块，接近 macOS 原生浮层滚动条。 */
const HIDE_AFTER_MS = 1000;

/** 让滚动条像系统原生那样滚动时出现、停下后隐藏：给正在滚动的元素加 is-scrolling，停下 HIDE_AFTER_MS 后去掉，
 * 滑块的显隐由 ui.css 按这个类决定。自定义 ::-webkit-scrollbar 后系统不再自动隐藏，所以要自己做（#241）。
 * 滚动事件不冒泡，在捕获阶段监听整个文档，弹窗、下拉这类挂在 body 下的滚动区域也覆盖到。返回取消监听的函数。 */
export function watchScrollbars(doc: Document = document): () => void {
  const timers = new WeakMap<Element, number>();
  const onScroll = (e: Event) => {
    const el = e.target;
    // 外壳铺满视口，页面本身不滚动，只处理元素
    if (!(el instanceof Element)) return;
    el.classList.add("is-scrolling");
    window.clearTimeout(timers.get(el));
    timers.set(el, window.setTimeout(() => el.classList.remove("is-scrolling"), HIDE_AFTER_MS));
  };
  doc.addEventListener("scroll", onScroll, { capture: true, passive: true });
  return () => doc.removeEventListener("scroll", onScroll, { capture: true });
}
